import React from 'react';
import { Flex, Text, Th } from '@chakra-ui/react';
import { flexRender } from '@tanstack/react-table';

export default function SortableTableHeader({ header, borderColor }) {
  const canSort = header.column.getCanSort();
  const sorted = header.column.getIsSorted();
  const meta = header.column.columnDef.meta ?? {};

  return (
    <Th
      borderColor={borderColor}
      minW={meta.minWidth}
      w={meta.width}
      maxW={meta.maxWidth}
      pe="10px"
      cursor={canSort ? 'pointer' : 'default'}
      userSelect="none"
      onClick={canSort ? header.column.getToggleSortingHandler() : undefined}
      _hover={canSort ? { bg: 'gray.50' } : undefined}
    >
      <Flex
        justify="space-between"
        align="center"
        fontSize={{ sm: '10px', lg: '12px' }}
        gap={1}
      >
        {flexRender(header.column.columnDef.header, header.getContext())}
        {canSort ? (
          <Text as="span" color={sorted ? 'blue.500' : 'gray.400'} fontSize="xs" lineHeight={1}>
            {sorted === 'asc' ? '↑' : sorted === 'desc' ? '↓' : '↕'}
          </Text>
        ) : null}
      </Flex>
    </Th>
  );
}
